/**
 * The two font stacks, as plain strings.
 *
 * They live outside `theme.ts` because the site's sections are Server
 * Components: an `sx` value written as a `(theme) => …` callback cannot cross
 * the server/client boundary, so a section that needs the display face reaches
 * for this constant instead of reading it off the theme at render time.
 *
 * The CSS variables are declared by `next/font` in the root layout.
 */

/** Saira Condensed — the enamel-sign lettering. Headings and small caps labels. */
export const DISPLAY_FONT =
  'var(--font-saira-condensed), var(--font-archivo), system-ui, sans-serif';

/** Archivo — normal-width text under the condensed caps. Prose, prices, buttons. */
export const TEXT_FONT = 'var(--font-archivo), system-ui, -apple-system, sans-serif';
